import React from "react";
import Image from "../elements/Image";
const ShowcaseItem = ({data}) => {
 
  return (
    <div className="w-full relative">
        <div className="rounded-2xl overflow-hidden bg-gradient-to-b from-[#1D0654] via-[#7C26FA] to-[#5311B3] pt-8 2xl:pt-10 pb-8 xl:pb-14 2xl:pb-20 h-full px-8 w-full relative z-[2]">
            {data?.caseTitle && (
                <div className="text-white font-bold text-xl xl:text-2xl capitalize mb-5">{data?.caseTitle}</div>
            )}
            {data?.caseDescription && (
                <div className="text-sm xl:text-base 2xl:text-lg text-white font-light" dangerouslySetInnerHTML={{ __html: data.caseDescription }}></div>
            )}
            {data?.caseInfo && (
                <div className="text-white text-sm 2xl:text-base font-bold mt-20">{data?.caseInfo}</div>
            )}
            
            <div className="w-24 xl:w-32 2xl:w-40 aspect-square absolute z-[-1] bottom-2 right-5">
                <Image
                  src={require("../../assets/images/Footer logo.png")}
                  classes={"object-contain opacity-15"}
                />
            </div>
        </div>
        <div className="bg-gradient-to-b from-[#F47414] via-[#CC1117] to-[#F90A42] absolute z-[1]  w-full left-4 2xl:left-8 top-4 2xl:top-8 rounded-2xl overflow-hidden h-full"></div>
    </div>
  );
};

export default ShowcaseItem;
